import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

const getTagGQL = ({ tagIds }) => {
  const query = `
      query ($tagIds: [ID!]){
          getTags(tagIds: $tagIds){
            edges{
                node{
                    id
                    value
                    type
                }
            }
          }
      }
   `
  const params = { tagIds }
  return callAuthorizedGraphQLEndpoint(query, params)
}

const editTagGQL = ({ id, value, type }) => {
  const sql = `
      mutation editTag($input: EditTagInput!){
          editTag(input: $input) { 
            id
            value
            type
            }
      }
   `
  const params = { input: { value, type, id } }
  return callAuthorizedGraphQLEndpoint(sql, params)
}

export { getTagGQL, editTagGQL }



// WEBPACK FOOTER //
// ./src/Containers/Settings/TagsManagement/TagsManagementEdit/gql.js